export enum MboCheckPermissions {
  MboCheck = 'mbo-check',
  MboCheckService = 'mbo-check-webservice',
  SignupStatusAlias = 'signup-status-alias',
  MboWebserviceConnection = 'mbo-webservices-connection',
  MboWebserviceLog = 'mbo-webservices-log',
  MboCheckFetchService = 'mbo-check-fetch-service',
  NationalMboCheckApiIncomingData = 'national-mbo-check-api-incoming-data',
}
